// "Open as league admin": asks the server for a short-lived sign-in link
// (POST /platform/leagues/:id/impersonate) and opens it in a new tab.

import { useState } from 'react'
import { api } from '@/api'
import { errorMessage } from '@/api/client'
import { Button, ExternalLinkIcon, useToast } from '@/components/ui'

export function ImpersonateButton({ tenantId, tenantName, disabled }: { tenantId: number; tenantName: string; disabled?: boolean }) {
  const toast = useToast()
  const [pending, setPending] = useState(false)

  const open = async () => {
    // Open the tab synchronously (inside the click) so pop-up blockers allow
    // it, then point it at the link once the server answers.
    const win = window.open('about:blank', '_blank')
    if (win) win.opener = null
    setPending(true)
    try {
      const { url } = await api.tenants.impersonationLink(tenantId)
      if (win) win.location.href = url
      else window.location.assign(url)
      toast.info(`Opened ${tenantName}'s admin in a new tab. The link expires in a few minutes.`)
    } catch (err) {
      win?.close()
      toast.error(`Couldn't open the league admin: ${errorMessage(err)}`)
    } finally {
      setPending(false)
    }
  }

  return (
    <Button
      size="sm"
      onClick={open}
      loading={pending}
      disabled={disabled}
      title={`Sign in to ${tenantName}'s admin as a super-admin`}
      icon={<ExternalLinkIcon size={14} />}
    >
      Open as league admin
    </Button>
  )
}
